// lib
import labelMatch, { errorLabelMatch } from '@aytm/app/survey/editor/lib/logic/labels/labelMatch'

// constants
export const AYTM_LOGIC_STATEMENT_MATCH = /\[(([^[\]]+|\[([^\]]*][^[\]]+))(\[[^\]]*][^[\]]*)*)](?!])/gm
export const AYTM_LOGIC_ESCAPE_BRACKET_MATCH = /(\[\[+)[^[\]]*(]]+)/gm
export const AYTM_LOGIC_ESCAPE_BRACKET_REGEXP = new RegExp(AYTM_LOGIC_ESCAPE_BRACKET_MATCH, 'm')
export const AYTM_LOGIC_STATEMENT_STRING_MATCH = /"([^"[\]]*)"/gm
export const AYTM_LOGIC_TOKEN_MATCH = /[a-z]\w*/i

export function extractLogicStatementsFromText(text = '') {
  const statements = text.match(AYTM_LOGIC_STATEMENT_MATCH) || []
  return (
    statements
      // filter escaped bracket statement
      .filter(statement => !AYTM_LOGIC_ESCAPE_BRACKET_REGEXP.test(statement))
      // remove [ and ] from statements
      .map(statement => statement.slice(1, -1))
  )
}

export function replaceLogicStatementsInText(text = '', replacer) {
  return text.replace(AYTM_LOGIC_STATEMENT_MATCH, statement =>
    AYTM_LOGIC_ESCAPE_BRACKET_REGEXP.test(statement) ? statement : `[${replacer(statement.slice(1, -1))}]`
  )
}

export function extractRefsFromLogicStatement(statement = '') {
  const refs = []
  let match
  while (null !== (match = labelMatch.exec(statement))) {
    refs.push(match[2])
  }
  return refs
}

export function extractErrorRefsFromLogicStatement(statement = '') {
  const refs = []
  let match
  while (null !== (match = errorLabelMatch.exec(statement))) {
    refs.push(match[1])
  }
  return refs
}
